import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import _ from 'lodash';
import {
  fetchPerson,
  setPerson,
  setPersonForm,
  deletePerson,
} from '../../../store/modules/person';
import { deleteFile } from '../../../store/modules/file';

import Person from '../components/Person';

const mapActionCreators = {
  fetchPerson,
  setPerson,
  setPersonForm,
  deletePerson,
  deleteFile,
  push,
};

const mapStateToProps = state => ({
  person: state.person.persons[state.person.current],
  formOpen: state.person.formOpen,
  personCount: Object.keys(
    _.filter(state.person.persons, o => o.deleted_at === null),
  ).length,
  activities: _.filter(
    _.pick(
      state.activity.activities,
      state.person.persons[state.person.current]
        ? state.person.persons[state.person.current].activities
        : null,
    ),
    ['deleted_at', null],
  ),
  projects: _.filter(
    _.pick(
      state.project.projects,
      state.person.persons[state.person.current]
        ? state.person.persons[state.person.current].projects
        : null,
    ),
    ['deleted_at', null],
  ),
  companies: _.filter(
    _.pick(
      state.company.companies,
      state.person.persons[state.person.current]
        ? state.person.persons[state.person.current].companies
        : null,
    ),
    ['deleted_at', null],
  ),
  files: _.filter(
    _.pick(
      state.file.files,
      state.person.persons[state.person.current]
        ? state.person.persons[state.person.current].files
        : null,
    ),
    ['deleted_at', null],
  ),
  tasks: _.filter(
    _.pick(
      state.task.tasks,
      state.person.persons[state.person.current]
        ? state.person.persons[state.person.current].tasks
        : null,
    ),
    ['deleted_at', null],
  ),
  persons: _.filter(
    _.pick(
      state.person.persons,
      state.person.persons[state.person.current]
        ? state.person.persons[state.person.current].persons
        : null,
    ),
    ['deleted_at', null],
  ),
  staffs: _.filter(state.staff.staffs, ['deleted_at', null]),
  fetching: state.person.fetching,
});

export default connect(mapStateToProps, mapActionCreators)(Person);



// WEBPACK FOOTER //
// ./src/routes/PersonDetail/containers/PersonContainer.js